/**
 * Staff "view as customer" — shared constants.
 *
 * Staff open the customer portal with `?as_user=<portal user id>`; the portal
 * records the impersonation through `record_staff_view_as(...)` and keeps the
 * choice in sessionStorage/localStorage under VIEW_AS_STORAGE_KEY so it
 * survives in-app navigation. The admin app builds the link with
 * `resolveAppUrl('customer-portal', ...)` from @pazportal/ui.
 */

/** Query-string parameter carrying the target portal user's id. */
export const VIEW_AS_QUERY_PARAM = 'as_user';

/** Browser storage key holding the active view-as user id. */
export const VIEW_AS_STORAGE_KEY = 'pazportal:view_as_user_id';
